import type { ComponentChildren } from 'preact';

/** Shared props for layout primitives. */
export interface UiBaseProps {
  className?: string;
  children?: ComponentChildren;
}

export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
